<template>
	<div class="form">
		<h4 class="step-title">
			What kind of insurance are you interested in?
		</h4>
		<div
			class="step-content d-flex flex-column align-items-center step-button-list wider"
		>
			<scrollable-button-list
				v-bind:items="insuranceTypes"
				v-bind:onclick="complete"
				v-bind:value="lead.insuranceType"
			/>
		</div>
	</div>
</template>

<script>
import ScrollableButtonList from "./shared/ScrollableButtonList.vue";

export default {
	name: "InsuranceType",
	components: {
		ScrollableButtonList,
	},
	data: function () {
		return {
			insuranceTypes: [
				{ text: "Auto", value: "AutoInsurance" },
				{ text: "Home", value: "HomeInsurance" },
			],
		};
	},
	props: {
		lead: Object,
	},
	methods: {
		complete: function (value) {
			this.lead.insuranceType = value;
			this.$emit("complete", this.$options.name, this.lead.insuranceType);
		},
	},
};
</script>
